import { render, staticRenderFns } from "./platformIndex.vue?vue&type=template&id=4bfd4f22"
import script from "./platformIndex.vue?vue&type=script&lang=js"
export * from "./platformIndex.vue?vue&type=script&lang=js"
import style0 from "./platformIndex.vue?vue&type=style&index=0&id=4bfd4f22&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports